<template>
  <v-layout align-start>
    <v-flex v-if="this.indice == 1">
      <v-card flat tile>
        <v-card class="mt-5 d-flex justify-center" flat tile>
          <v-img src="@/assets/logo.jpg" width="150" height="150" contain />
        </v-card>
        <p class="font-weight-bold text-center mt-3">
          Gracias por realizar nuestra encuesta!
        </p>
      </v-card>
    </v-flex>

    <v-flex v-if="this.indice == 2">
      <v-card flat tile>
        <v-card class="mt-5 d-flex justify-center" flat tile>
          <v-img src="@/assets/logo.jpg" width="150" height="150" contain />
        </v-card>
        <p class="font-weight-bold text-center mt-3">
          No se encuetra la pagina.
        </p>
      </v-card>
    </v-flex>

    <v-flex v-if="this.indice == 0">
      <v-card class="d-flex flex-row-reverse" flat tile>
        <v-card class="mt-5 mr-5" flat tile>
          <v-img src="@/assets/logo.jpg" width="150" height="150" contain />
        </v-card>
      </v-card>

      <v-form v-model="valid" class="pa-5" style="background-color: white">
        <p class="font-weight-bold text-center">
          ENCUESTA DE EVALUACION DE SERVICIO
        </p>
        <v-container class="white lighten-5 mb-6">
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2" outlined tile>
                Fecha de asistencia:
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-text-field
                  v-model="fecha"
                  label="Fecha de asistencia"
                  disabled
                  hide-details
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="white lighten-5 mb-6">
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2" outlined tile>
                Compañía de seguros:
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-text-field
                  v-model="compañia"
                  label="Compañía de seguros"
                  disabled
                  hide-details
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="white lighten-5 mb-6">
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2" outlined tile>
                Placa de vehículo asegurado:
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-text-field
                  v-model="placa"
                  label="Placa de vehículo asegurado"
                  disabled
                  hide-details
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="white lighten-5 mb-6">
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2" outlined tile>
                País:
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-text-field
                  v-model="pais"
                  label="País"
                  disabled
                  hide-details
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="white lighten-5 mb-6">
          <p class="font-weight-bold">
            Seleccione la alternativa que considere satisfactoria.
          </p>
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2 font-weight-bold" outlined tile>
                ¿Como evalúa la atención telefónica cuando reporto su
                emergencia?
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-radio-group row v-model="atencion_Telefonico">
                  <v-radio
                    label="Excelente"
                    value="Excelente"
                    color="success"
                  ></v-radio>
                  <v-radio label="Bueno" value="Bueno" color="info"></v-radio>
                  <v-radio label="Malo" value="Malo" color="error"></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2 font-weight-bold" outlined tile>
                ¿Como evalúa la atención del asesor de asistencia?
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-radio-group row v-model="atencion_Asesor">
                  <v-radio
                    label="Excelente"
                    value="Excelente"
                    color="success"
                  ></v-radio>
                  <v-radio label="Bueno" value="Bueno" color="info"></v-radio>
                  <v-radio label="Malo" value="Malo" color="error"></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2 font-weight-bold" outlined tile>
                ¿Como califica la presentación del asesor que llego al lugar de
                la asistencia?
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-radio-group row v-model="presentacion_Asesor">
                  <v-radio
                    label="Excelente"
                    value="Excelente"
                    color="success"
                  ></v-radio>
                  <v-radio label="Bueno" value="Bueno" color="info"></v-radio>
                  <v-radio label="Malo" value="Malo" color="error"></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2 font-weight-bold" outlined tile>
                ¿El asesor le explico el procedimiento a seguir para la
                resolución de su reclamo?
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-radio-group row v-model="explico_procedimiento">
                  <v-radio
                    label="Excelente"
                    value="Excelente"
                    color="success"
                  ></v-radio>
                  <v-radio label="Bueno" value="Bueno" color="info"></v-radio>
                  <v-radio label="Malo" value="Malo" color="error"></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="white lighten-5 mb-6">
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2 font-weight-bold" outlined tile>
                ¿Fue influenciado en alguna decisión por parte del asesor?
              </v-card>
            </v-col>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-radio-group row v-model="influenciado_Por_Asesor">
                  <v-radio label="Si" value="Si" color="error"></v-radio>
                  <v-radio label="No" value="No" color="info"></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="white lighten-5 mb-6">
          <v-col>
            <v-card class="pa-2 font-weight-bold" outlined tile>
              ¿Por qué? Explique:
            </v-card>
          </v-col>
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-textarea
                  v-model="influenciado_Por_Asesor_Porque"
                  hide-details
                  outlined
                  name="input-7-4"
                  label="¿Por qué? Explique:"
                ></v-textarea>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="white lighten-5 mb-6">
          <v-col>
            <v-card class="pa-2 font-weight-bold" outlined tile>
              Comentario adicional o sugerencia favor detallarla en el cuadro
              siguiente:
            </v-card>
          </v-col>
          <v-row align="center" no-gutters>
            <v-col>
              <v-card class="pa-2" flat tile>
                <v-textarea
                  v-model="comentario_Adicional"
                  hide-details
                  outlined
                  name="input-7-4"
                  label="Comentario"
                ></v-textarea>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-btn @click="actualizar()">Enviar respuestas</v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { dbEval } from "../main";

export default {
  data() {
    return {
      evaluaciones: [],
      valid: false,
      indice: null,
      id: "",
      numeroAsistencia: "",
      numeroAsistenciaEncrypt: "",
      fecha: "",
      compañia: "",
      placa: "",
      pais: "",
      atencion_Telefonico: "",
      atencion_Asesor: "",
      presentacion_Asesor: "",
      explico_procedimiento: "",
      influenciado_Por_Asesor: "",
      influenciado_Por_Asesor_Porque: "",
      comentario_Adicional: "",
      tipo_Encuesta: "",
      fecha_Actual: "",
      condicion: false,
      //variables para encriptar y desencriptar
      password: "root",
      keyStr:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      pcount: "",
    };
  },

  created() {
    this.listar();
  },

  methods: {
    listar() {
      let me = this;
      var evaluaciones = dbEval.collection("evaluaciones").doc(this.$route.params.id);
      evaluaciones
        .get()
        .then((doc) => {
          me.evaluaciones.push({
            id: doc.id,
            numeroAsistencia: doc.data().numeroAsistencia,
            fecha: doc.data().fecha,
            compañia: doc.data().compañia,
            placa: doc.data().placa,
            pais: doc.data().pais,
            atencion_Telefonico: doc.data().atencion_Telefonico,
            atencion_Asesor: doc.data().atencion_Asesor,
            presentacion_Asesor: doc.data().presentacion_Asesor,
            explico_procedimiento: doc.data().explico_procedimiento,
            influenciado_Por_Asesor: doc.data().influenciado_Por_Asesor,
            influenciado_Por_Asesor_Porque: doc.data()
              .influenciado_Por_Asesor_Porque,
            comentario_Adicional: doc.data().comentario_Adicional,
            fecha_Actual: doc.data().fecha_Actual,
            tipo_Encuesta: doc.data().tipo_Encuesta,
            condicion: doc.data().condicion,
          });
          if (
            me.evaluaciones[0].tipo_Encuesta == "ENCUESTA EVALUACION SERVICIO"
          ) {
            if (me.evaluaciones[0].condicion == true) {
              me.indice = 1;
            } else {
              me.indice = 0;
              me.verDetalles(me.evaluaciones);
            }
          }
        })
        .catch((error) => {
          this.$router.push({ name: "Home" });
        });
    },
    verDetalles(data) {
      this.id = data[0].id;
      console.log(data)
      this.numeroAsistencia = data[0].numeroAsistencia;
      this.condicion = data[0].condicion;
      this.fecha = data[0].fecha;
      this.compañia = data[0].compañia;
      this.placa = data[0].placa;
      this.pais = data[0].pais;
      this.atencion_Telefonico = data[0].atencion_Telefonico;
      this.atencion_Asesor = data[0].atencion_Asesor;
      this.presentacion_Asesor = data[0].presentacion_Asesor;
      this.explico_procedimiento = data[0].explico_procedimiento;
      this.influenciado_Por_Asesor = data[0].influenciado_Por_Asesor;
      this.influenciado_Por_Asesor_Porque =
        data[0].influenciado_Por_Asesor_Porque;
      this.comentario_Adicional = data[0].comentario_Adicional;
      this.tipo_Encuesta = data[0].tipo_Encuesta;
      this.fecha_Actual = data[0].fecha_Actual;
    },
    actualizar() {
      let me = this;
      dbEval.collection("evaluaciones")
        .doc(me.id)
        .update({
          numeroAsistencia: me.numeroAsistencia,
          condicion: true,
          fecha: me.fecha,
          compañia: me.compañia,
          placa: me.placa,
          pais: me.pais,
          atencion_Telefonico: me.atencion_Telefonico,
          atencion_Asesor: me.atencion_Asesor,
          presentacion_Asesor: me.presentacion_Asesor,
          explico_procedimiento: me.explico_procedimiento,
          influenciado_Por_Asesor: me.influenciado_Por_Asesor,
          influenciado_Por_Asesor_Porque: me.influenciado_Por_Asesor_Porque,
          comentario_Adicional: me.comentario_Adicional,
          tipo_Encuesta: me.tipo_Encuesta,
          fecha_Actual: me.fecha_Actual,
        })
        .then(() => {
          me.mostrarMensaje();
        });
    },
    mostrarMensaje() {
      this.indice = 1;
    },
    encrypt() {
      var vm = this;
      var v = new Array(2);
      var k = new Array(4);
      var s = "";
      var i = "";
      vm.numeroAsistenciaEncrypt = vm.$route.params.id;
      var plaintext = vm.escCtrlCh(vm.numeroAsistenciaEncrypt);
      var password = vm.password;
      for (var i = 0; i < 4; i++)
        k[i] = vm.Str4ToLong(password.slice(i * 4, (i + 1) * 4));
      for (i = 0; i < plaintext.length; i += 8) {
        v[0] = vm.Str4ToLong(plaintext.slice(i, i + 4));
        v[1] = vm.Str4ToLong(plaintext.slice(i + 4, i + 8));
        vm.code(v, k);
        s += vm.LongToStr4(v[0]) + vm.LongToStr4(v[1]);
      }
      var input = vm.escCtrlCh(s);
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output +=
          vm.keyStr.charAt(enc1) +
          vm.keyStr.charAt(enc2) +
          vm.keyStr.charAt(enc3) +
          vm.keyStr.charAt(enc4);
      }
      vm.numeroAsistenciaEncrypt = output;
    },
    decrypt(ruta) {
      var vm = this;
      var input = ruta;
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = vm.keyStr.indexOf(input.charAt(i++));
        enc2 = vm.keyStr.indexOf(input.charAt(i++));
        enc3 = vm.keyStr.indexOf(input.charAt(i++));
        enc4 = vm.keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output += String.fromCharCode(chr1);
        if (enc3 != 64) {
          output += String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output += String.fromCharCode(chr3);
        }
      }
      output = output.toString();
      var v = new Array(2);
      var k = new Array(4);
      var s = "";
      var i = "";
      var ciphertext = vm.unescCtrlCh(output);
      var password = vm.password;
      for (var i = 0; i < 4; i++)
        k[i] = vm.Str4ToLong(password.slice(i * 4, (i + 1) * 4));
      for (i = 0; i < ciphertext.length; i += 8) {
        v[0] = vm.Str4ToLong(ciphertext.slice(i, i + 4));
        v[1] = vm.Str4ToLong(ciphertext.slice(i + 4, i + 8));
        vm.decode(v, k);
        s += vm.LongToStr4(v[0]) + vm.LongToStr4(v[1]);
      }
      s = s.replace(/\0+$/, "");
      vm.numeroAsistenciaEncrypt = vm.unescCtrlCh(s);
    },
    genradpas() {
      var vm = this;
      var chars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890!@#$%&*-+=?";
      var charsarr = chars.split("");
      var pasoutarr = new Array();
      for (var x = 0; x < 16; x++) {
        pasoutarr[x] = charsarr[Math.floor(Math.random() * 73)];
      }
      var pasout = pasoutarr.join("");
      vm.password = pasout;
      vm.pcount = "16";
    },
    Str4ToLong(s) {
      var v = 0;
      for (var i = 0; i < 4; i++) v |= s.charCodeAt(i) << (i * 8);
      return isNaN(v) ? 0 : v;
    },
    LongToStr4(v) {
      var s = String.fromCharCode(
        v & 0xff,
        (v >> 8) & 0xff,
        (v >> 16) & 0xff,
        (v >> 24) & 0xff
      );
      return s;
    },
    escCtrlCh(str) {
      return str.replace(/[\0\t\n\v\f\r\xa0'"!]/g, function(c) {
        return "!" + c.charCodeAt(0) + "!";
      });
    },
    unescCtrlCh(str) {
      return str.replace(/!\d\d?\d?!/g, function(c) {
        return String.fromCharCode(c.slice(1, -1));
      });
    },
    code(v, k) {
      var y = v[0],
        z = v[1];
      var delta = 0x9e3779b9;
      var limit = delta * 32;
      var sum = 0;
      while (sum != limit) {
        y += (((z << 4) ^ (z >>> 5)) + z) ^ (sum + k[sum & 3]);
        sum += delta;
        z += (((y << 4) ^ (y >>> 5)) + y) ^ (sum + k[(sum >>> 11) & 3]);
      }
      v[0] = y;
      v[1] = z;
    },
    decode(v, k) {
      var y = v[0],
        z = v[1];
      var delta = 0x9e3779b9;
      var sum = delta * 32;
      while (sum != 0) {
        z -= (((y << 4) ^ (y >>> 5)) + y) ^ (sum + k[(sum >>> 11) & 3]);
        sum -= delta;
        y -= (((z << 4) ^ (z >>> 5)) + z) ^ (sum + k[sum & 3]);
      }
      v[0] = y;
      v[1] = z;
    },
  },
};
</script>
